import { useEffect } from "react";

const CANONICAL_ORIGIN = "https://scmbrain.com";
const CANONICAL_HOSTS = ["scmbrain.com", "www.scmbrain.com"];

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setRobots(block) {
  let el = document.head.querySelector('meta[name="robots"]');
  if (block) {
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
  } else if (el) {
    el.remove();
  }
}

/**
 * Per-page document metadata. Updates the single existing <title>/<meta>/<link>
 * tags (seeded in index.html) instead of appending duplicates, so each route has
 * exactly one canonical, description, and set of OG/Twitter tags.
 * On non-canonical hosts (preview/staging/*.emergent.host) or when noindex is set,
 * a noindex directive is emitted so only the production domain gets indexed.
 */
export const Seo = ({ title, description, path = "/", image, noindex = false }) => {
  useEffect(() => {
    const canonical = `${CANONICAL_ORIGIN}${path}`;
    const ogImage = image || `${CANONICAL_ORIGIN}/og-image.jpg`;
    const host = window.location.hostname;
    const blockIndex = noindex || !CANONICAL_HOSTS.includes(host);

    if (title) document.title = title;
    if (description) upsertMeta("name", "description", description);
    upsertLink("canonical", canonical);
    setRobots(blockIndex);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImage);

    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);
  }, [title, description, path, image, noindex]);

  return null;
};

export default Seo;
